module.exports = __webpack_public_path__ + "img/gd.fe11eb51.png";